export default __webpack_public_path__ + "783b53eaef088ff6bd0266549efdfb96.png";